import axiosInstance, { endpoints } from "../../lib/axios";
import { IAnvändare } from "../../types/nya/common";
import { toast } from "src/components/snackbar";
import axios from "../../lib/axios";


export function hämtaAnvändare(): Promise<IAnvändare> {

  return axiosInstance.get(endpoints.användare.root)
    .then(response => {
      return response.data
    });
}

// BRF Bofinken org ID — all new users are connected to this organisation by default
const BRF_BOFINKEN_ORG_ID = 'bf27f120-56ad-4a82-bc8a-36965bc77689';

export interface SkapaAnvändareRequest {
  email: string;
  förnamn: string;
  efternamn: string;
  orgId: string;
}

export function skapaAnvändare(request: SkapaAnvändareRequest): Promise<IAnvändare> {
  return axiosInstance.post(endpoints.användare.root, {
    ...request,
    orgId: BRF_BOFINKEN_ORG_ID,
  }).then(response => response.data);
}

export function hämtaAllaAnvändare(): Promise<IAnvändare[]> {
  return axiosInstance.get(endpoints.användare.admin.alla)
    .then(response => response.data);
}

export function uppdateraKoppladeOrganisationer(användarId: string, orgIds: string[]): Promise<IAnvändare> {
  return axiosInstance.put(endpoints.användare.admin.uppdateraOrganisationer(användarId), orgIds)
    .then(response => response.data);
}

export function markeraOnboardingSomKlar(): Promise<IAnvändare> {
  return axiosInstance.post(endpoints.användare.onboardingKlar)
    .then(response => response.data);
}
